<soft-page>
  <soft-page-header [customClass]="'!p-0'">
    <div class="w-full mb-4">
      <soft-default-header
        [title]="steps[1].header | translate"
        [subtitle]="steps[1].subHeader | translate"
      />
      <soft-ds-progress-steps class="mx-2" [steps]="steps" [currentIndex]="1" />
    </div>
  </soft-page-header>

  <soft-panel [titleTemplate]="InhaltTitle" [softCardStyle]="false" class="my-4">
    <ng-template #InhaltTitle>
      <div class="soft-overline mt-4">
        {{'#INVENTUR.PAGES.ARTIKEL_AUSWAHL.ARTIKEL' | translate}}
      </div>
    </ng-template>
    <soft-artikel-menge-auswahl
      [lagerplatzInhalt]="inhalt()"
      (artikelMengeChange)="onSelect($event)"
    />
  </soft-panel>

  <soft-panel [titleTemplate]="InhaltInvTitle" [softCardStyle]="false" class="pb-4">
    <ng-template #InhaltInvTitle>
      <div class="soft-overline mt-4">
        {{'#INVENTUR.PAGES.ARTIKEL_AUSWAHL.ARTIKEL_INV' | translate}}
      </div>
    </ng-template>
    <soft-artikel-menge-auswahl
      [lagerplatzInhalt]="inhaltInv()"
      [showInvMenge]="true"
      (artikelMengeChange)="onSelect($event)"
    />
  </soft-panel>

  @if (loading$ | async) {
  <soft-blocking-loading-spinner class="top-0 right-0" />
  }
</soft-page>
